var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "AudienceList",
      "extra-items": _vm.isReadOnly ? [{
        text: _vm.audience.title
      }] : _vm.isEdit ? [{
        text: _vm.audience.title,
        to: 'AudienceView',
        params: _vm.$route.params.audienceId
      }, '編輯受眾'] : ['新增受眾']
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "查看受眾" : _vm.isEdit ? "編輯受眾" : "新增受眾") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.isReadOnly
    }
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "受眾名稱"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.audience.title.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.audience.title,
      callback: function callback($$v) {
        _vm.$set(_vm.audience, "title", $$v);
      },
      expression: "audience.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.audience.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "受眾描述"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.audience.description,
      callback: function callback($$v) {
        _vm.$set(_vm.audience, "description", $$v);
      },
      expression: "audience.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "受眾來源"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.options
    },
    model: {
      value: _vm.audience.source,
      callback: function callback($$v) {
        _vm.$set(_vm.audience, "source", $$v);
      },
      expression: "audience.source"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.disabledBranchSelect
    },
    model: {
      value: _vm.audience.branch_id,
      callback: function callback($$v) {
        _vm.$set(_vm.audience, "branch_id", $$v);
      },
      expression: "audience.branch_id"
    }
  })], 1), _vm.audience.source == 'import' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "上傳"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "text": "上傳檔案"
    }
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload",
      modifiers: {
        "modal-upload": true
      }
    }],
    on: {
      "click": function click($event) {
        _vm.audience.source_type = 'line';
      }
    }
  }, [_vm._v(" LINE UID 匯入 ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload",
      modifiers: {
        "modal-upload": true
      }
    }],
    on: {
      "click": function click($event) {
        _vm.audience.source_type = 'phone';
      }
    }
  }, [_vm._v(" 手機匯入 ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload",
      modifiers: {
        "modal-upload": true
      }
    }],
    on: {
      "click": function click($event) {
        _vm.audience.source_type = 'code';
      }
    }
  }, [_vm._v(" 會員編號 ")])], 1)], 1) : _vm._e(), _vm.audience.source == 'filter' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "受眾條件"
    }
  }) : _vm._e(), _vm.audience.source == 'filter' ? _c('div', [_vm._l(_vm.audience.conditionSet.conditions, function (cs, idx) {
    return _c('div', {
      key: idx
    }, [idx != 0 ? _c('b-form-select', {
      staticClass: "w-auto my-3",
      attrs: {
        "options": [{
          text: '而且',
          value: 'AND'
        }, {
          text: '或',
          value: 'OR'
        }],
        "value": null
      },
      model: {
        value: _vm.audience.conditionSet.matched,
        callback: function callback($$v) {
          _vm.$set(_vm.audience.conditionSet, "matched", $$v);
        },
        expression: "audience.conditionSet.matched"
      }
    }) : _vm._e(), _c('b-card', {
      staticClass: "shadow-sm rounded rounded-3 p-2 d-flex",
      attrs: {
        "no-body": ""
      }
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "m-1"
    }, [_c('b-form-select', {
      staticClass: "w-auto bg-primary text-white",
      attrs: {
        "options": [{
          text: '全部符合條件',
          value: 'AND'
        }, {
          text: '符合任何一個',
          value: 'OR'
        }]
      },
      model: {
        value: cs.matched,
        callback: function callback($$v) {
          _vm.$set(cs, "matched", $$v);
        },
        expression: "cs.matched"
      }
    })], 1), _c('div', {
      staticClass: "\n                            d-flex\n                            align-items-center\n                            flex-wrap flex-fill\n                          "
    }, [_vm._l(cs.conditions, function (c, jdx) {
      return _c('div', {
        key: jdx
      }, [_c('b-card', {
        staticClass: "\n                                shadow-none\n                                rounded rounded-3\n                                bg-light\n                                p-2\n                                m-1\n                                condition\n                              ",
        attrs: {
          "no-body": ""
        }
      }, [_c('div', {
        staticClass: "d-flex align-items-center"
      }, [_c('div', {
        staticClass: "mr-2"
      }, [_c('b-form-select', {
        staticClass: "border-success",
        attrs: {
          "options": _vm.conditionEnum,
          "value-field": "type",
          "text-field": "label",
          "size": "sm"
        },
        on: {
          "change": function change(type) {
            _vm.changeCondition(idx, jdx, type);
          }
        },
        model: {
          value: c.type,
          callback: function callback($$v) {
            _vm.$set(c, "type", $$v);
          },
          expression: "c.type"
        }
      })], 1), c.operatorOptions ? _c('div', {
        staticClass: "mr-2"
      }, [_vm.isObject(c.operator) ? _c('b-form-select', {
        staticClass: "border-warning",
        attrs: {
          "options": c.operatorOptions.map(function (o) {
            return {
              text: o.text,
              value: o.value.operator
            };
          }),
          "size": "sm"
        },
        on: {
          "change": function change($event) {
            c.value = c.operatorOptions.find(function (o) {
              return o.value.operator == c.operator.operator;
            }).value.default;
          }
        },
        model: {
          value: c.operator.operator,
          callback: function callback($$v) {
            _vm.$set(c.operator, "operator", $$v);
          },
          expression: "c.operator.operator"
        }
      }) : _c('b-form-select', {
        staticClass: "border-warning",
        attrs: {
          "options": c.operatorOptions,
          "size": "sm"
        },
        on: {
          "change": function change($event) {
            c.value = c.operator.default;
          }
        },
        model: {
          value: c.operator,
          callback: function callback($$v) {
            _vm.$set(c, "operator", $$v);
          },
          expression: "c.operator"
        }
      })], 1) : _vm._e(), c.valueOptions ? _c('div', {
        staticClass: "mr-2"
      }, [_c('b-form-select', {
        staticClass: "border-warning",
        attrs: {
          "options": c.valueOptions,
          "size": "sm"
        },
        model: {
          value: c.value,
          callback: function callback($$v) {
            _vm.$set(c, "value", $$v);
          },
          expression: "c.value"
        }
      })], 1) : _vm._e(), c.operator ? _c('div', {
        staticClass: "mr-2"
      }, [['age', 'loyalty_current_level_amount', 'loyalty_total_spending_amount'].includes(c.type) ? [['lt', 'eq', 'gt'].includes(c.operator.operator) ? [_c('b-form-input', {
        attrs: {
          "type": "number",
          "min": "c.type == 'age' ? 1 : 0",
          "pattern": "[0-9]+",
          "placeholder": "\u8ACB\u8F38\u5165".concat(c.label)
        },
        model: {
          value: c.value,
          callback: function callback($$v) {
            _vm.$set(c, "value", $$v);
          },
          expression: "c.value"
        }
      })] : ['between'].includes(c.operator.operator) ? [_c('div', {
        staticClass: "d-flex align-items-center"
      }, [_c('b-form-input', {
        attrs: {
          "type": "number",
          "min": "c.type == 'age' ? 1 : 0",
          "pattern": "[0-9]+",
          "placeholder": "\u8ACB\u8F38\u5165".concat(c.label)
        },
        model: {
          value: c.value.from,
          callback: function callback($$v) {
            _vm.$set(c.value, "from", $$v);
          },
          expression: "c.value.from"
        }
      }), _c('div', {
        staticClass: "px-2"
      }, [_vm._v("-")]), _c('b-form-input', {
        attrs: {
          "type": "number",
          "min": "c.type == 'age' ? 1 : 0",
          "pattern": "[0-9]+",
          "placeholder": "\u8ACB\u8F38\u5165".concat(c.label)
        },
        model: {
          value: c.value.to,
          callback: function callback($$v) {
            _vm.$set(c.value, "to", $$v);
          },
          expression: "c.value.to"
        }
      })], 1)] : _vm._e()] : _vm._e(), ['include', 'exclude'].includes(c.operator) ? [_c('b-form-input', {
        attrs: {
          "placeholder": "\u8ACB\u8F38\u5165".concat(c.label)
        },
        model: {
          value: c.value,
          callback: function callback($$v) {
            _vm.$set(c, "value", $$v);
          },
          expression: "c.value"
        }
      })] : _vm._e(), ['birthday', 'created_at', 'registered_at'].includes(c.type) ? [['lt', 'eq', 'gt'].includes(c.operator.operator) ? [_c('datepicker', {
        attrs: {
          "bootstrap-styling": "",
          "format": "yyyy-MM-dd",
          "language": _vm.zh,
          "disabled": _vm.isReadOnly
        },
        model: {
          value: c.value,
          callback: function callback($$v) {
            _vm.$set(c, "value", $$v);
          },
          expression: "c.value"
        }
      })] : ['between'].includes(c.operator.operator) && c.value.from ? [_c('div', {
        staticClass: "d-flex align-items-center"
      }, [_c('datepicker', {
        attrs: {
          "bootstrap-styling": "",
          "format": "yyyy-MM-dd",
          "language": _vm.zh,
          "disabled": _vm.isReadOnly
        },
        model: {
          value: c.value.from,
          callback: function callback($$v) {
            _vm.$set(c.value, "from", $$v);
          },
          expression: "c.value.from"
        }
      }), _c('div', {
        staticClass: "px-2"
      }, [_vm._v("-")]), _c('datepicker', {
        attrs: {
          "bootstrap-styling": "",
          "format": "yyyy-MM-dd",
          "language": _vm.zh,
          "disabled": _vm.isReadOnly,
          "disabled-dates": {
            to: c.value.from
          }
        },
        model: {
          value: c.value.to,
          callback: function callback($$v) {
            _vm.$set(c.value, "to", $$v);
          },
          expression: "c.value.to"
        }
      })], 1)] : ['date-eq'].includes(c.operator.operator) ? [_c('div', {
        staticClass: "d-flex"
      }, [_c('b-form-select', {
        attrs: {
          "options": _vm.monthOptions(),
          "size": "sm"
        },
        model: {
          value: c.value.month,
          callback: function callback($$v) {
            _vm.$set(c.value, "month", $$v);
          },
          expression: "c.value.month"
        }
      }), _c('b-form-select', {
        attrs: {
          "options": _vm.dayOptions(c.value.month),
          "size": "sm"
        },
        model: {
          value: c.value.day,
          callback: function callback($$v) {
            _vm.$set(c.value, "day", $$v);
          },
          expression: "c.value.day"
        }
      })], 1)] : ['date-between'].includes(c.operator.operator) && c.value.from && c.value.to ? [_c('div', {
        staticClass: "d-flex align-items-center"
      }, [_c('b-form-select', {
        staticClass: "mr-2",
        attrs: {
          "options": _vm.monthOptions(),
          "size": "sm"
        },
        model: {
          value: c.value.from.month,
          callback: function callback($$v) {
            _vm.$set(c.value.from, "month", $$v);
          },
          expression: "c.value.from.month"
        }
      }), _c('b-form-select', {
        attrs: {
          "options": _vm.dayOptions(c.value.from.month),
          "size": "sm"
        },
        model: {
          value: c.value.from.day,
          callback: function callback($$v) {
            _vm.$set(c.value.from, "day", $$v);
          },
          expression: "c.value.from.day"
        }
      }), _c('div', {
        staticClass: "px-2"
      }, [_vm._v("-")]), _c('b-form-select', {
        staticClass: "mr-2",
        attrs: {
          "options": _vm.monthOptions(),
          "size": "sm"
        },
        model: {
          value: c.value.to.month,
          callback: function callback($$v) {
            _vm.$set(c.value.to, "month", $$v);
          },
          expression: "c.value.to.month"
        }
      }), _c('b-form-select', {
        attrs: {
          "options": _vm.dayOptions(c.value.to.month),
          "size": "sm"
        },
        model: {
          value: c.value.to.day,
          callback: function callback($$v) {
            _vm.$set(c.value.to, "day", $$v);
          },
          expression: "c.value.to.day"
        }
      })], 1)] : _vm._e()] : _vm._e()], 2) : _vm._e(), _c('div', [_c('b-button', {
        staticClass: "px-2 py-1",
        attrs: {
          "variant": "danger",
          "size": "sm",
          "pill": ""
        },
        on: {
          "click": function click($event) {
            return cs.conditions.splice(jdx, 1);
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times mx-0",
        attrs: {
          "aria-hidden": "true"
        }
      })])], 1)])])], 1);
    }), _c('div', {
      staticStyle: {
        "flex-basis": "100%",
        "height": "0"
      }
    }), _c('div', [_c('b-form-select', {
      staticClass: "m-1 border-success",
      attrs: {
        "options": _vm.conditionEnum,
        "value-field": "type",
        "text-field": "label"
      },
      on: {
        "change": function change(type) {
          return _vm.addCondition(cs, type);
        }
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v("-- 增加條件 --")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.selectAddCondition,
        callback: function callback($$v) {
          _vm.selectAddCondition = $$v;
        },
        expression: "selectAddCondition"
      }
    })], 1)], 2), idx != 0 ? _c('div', [_c('b-button', {
      staticClass: "text-dark",
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.audience.conditionSet.conditions.splice(idx, 1);
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-2x fa-trash-o m-0",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e()])])], 1);
  }), _c('br'), _c('b-form-select', {
    staticClass: "w-auto my-3",
    attrs: {
      "options": [{
        text: '而且',
        value: 'AND'
      }, {
        text: '或',
        value: 'OR'
      }],
      "value": null
    },
    on: {
      "change": function change(setMatched) {
        return _vm.addConditionSet(setMatched);
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("-- 新增條件組合 --")])];
      },
      proxy: true
    }], null, false, 2409244151),
    model: {
      value: _vm.selectAddConditionSet,
      callback: function callback($$v) {
        _vm.selectAddConditionSet = $$v;
      },
      expression: "selectAddConditionSet"
    }
  })], 2) : _vm._e()], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [!_vm.isReadOnly ? _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("返回 ")]) : _vm._e(), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)])], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": "批次上傳"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "href": "/excel/audience_".concat(_vm.audience.source_type, ".xlsx")
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        }), _vm._v("下載範例檔案")]), _c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_vm.audience.source_type == 'code' ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請選擇通路")]), _c('b-form-select', {
    attrs: {
      "options": _vm.nonLineMerchants
    },
    model: {
      value: _vm.audience.source_merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.audience, "source_merchant_id", $$v);
      },
      expression: "audience.source_merchant_id"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請上傳 Excel 檔案")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": _vm.upload
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }